<template>
	<div>
		<v-snackbar v-model="savedNotif" top>
			Document Saved
			<v-btn color="pink" flat @click="savedNotif = false">
				Close
			</v-btn>
		</v-snackbar>

		<v-snackbar v-model="snackbar.show" top :color="snackbar.color">
			{{snackbar.message}}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false">
				Close
			</v-btn>
		</v-snackbar>

		<loading-modal v-if="isLoading" loading-text="Loading Policy..." />

		<hr-document-editor 
			v-if="hrDocument != null" 
			:is-admin="loggedInEmployee.isAdmin" 
			:is-saving="isSaving" 
			:hr-document="hrDocument" 
			@save="save" 
			@cancel="onCancel">
		</hr-document-editor>	
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import HrDocumentEditor from '@/components/hrDocuments/HrDocumentEditor';
	import LoadingModal from '@/components/LoadingModal';

	export default {
		name: 'PageHrDocumentEdit',
		props: {
			id: {
				required: true
			}
		},
		data() {
			return {
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink'
				},
				savedNotif: false,
				isSaving: false,
				hrDocument: null,
				isLoading: false
			};
		},
		components: {
			HrDocumentEditor,
			LoadingModal
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			}),
		},
		methods: {
			save(hrDocument) {
				this.isSaving = true;
				this.$store.dispatch('hrDocuments/edit', hrDocument).then(
					response => {
						this.isSaving = false;
						// this.savedNotif = true;
						this.$router.push(`/hrDocuments/${hrDocument.id}/`);
					},
					error => {
						this.isSaving = false;
						console.error('Error saving HR Document');
					}
				);
			},
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : 'undefined';
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000
			},
			onCancel() {
				window.history.back();
			}
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Edit Policy');

			this.isLoading = true;
			this.$store.dispatch('hrDocuments/getById', this.id).then(
				(hrDocument) => {
					this.isLoading = false;
					this.hrDocument = hrDocument;
				},
				(error) => {
					this.isLoading = false;
					this.showSnackbar('An error occurred loading document', true);
				}
			);
		}
	};
</script>

<style></style>
